// How a ProjectEnablementList saves: each tick at once, or a selection the caller submits.
export type Saving =
  | {
      /** Each tick saves at once; the enabled projects can be unticked from their list. */
      mode: "per-tick";
      pending: string | undefined;
      failed: string | undefined;
      error: Error | null;
    }
  | {
      /** Ticks only pick projects; the caller's controls switch the selection on. */
      mode: "batched";
      selected: Set<string>;
      max: number;
      busy: boolean;
    };

/** The per-tick saving state of a mutation that takes the project per call. */
export const perTick = (mutation: {
  isLoading: boolean;
  isError: boolean;
  variables?: { project_id: string };
  error: Error | null;
}): Saving => ({
  mode: "per-tick",
  pending: mutation.isLoading ? mutation.variables?.project_id : undefined,
  failed: mutation.isError ? mutation.variables?.project_id : undefined,
  error: mutation.error,
});
